import type { ResultStatusCode } from './result-status.models';

export interface SummaryEntry {
  humanId?: string | null;
  dogId?: string | null;
  statusCode?: ResultStatusCode;
}

export function summarizeEvent(entries: SummaryEntry[]) {
  const humans = new Set<string>();
  const dogs = new Set<string>();
  let unidentified = 0, dnf = 0, dns = 0, dsq = 0;
  for (const entry of entries) {
    if (entry.humanId) humans.add(entry.humanId); else unidentified++;
    if (entry.dogId) dogs.add(entry.dogId);
    if (entry.statusCode === 'dnf') dnf++;
    if (entry.statusCode === 'dns') dns++;
    if (entry.statusCode === 'dsq') dsq++;
  }
  return { total: entries.length, humans: humans.size, dogs: dogs.size, unidentified, dnf, dns, dsq };
}
